/** Default `viewCustom` for the events search view (calendar card colors, PDF margin, hover details). */
export const EVENTS_VIEW_CUSTOM_DEFAULTS = {
    colorBy: "type" as const,
    showEventTypeShortName: false,
    planningPrintPdfMarginMm: 8,
    /** When true, the whole calendar event tile opens the event details hover card on hover. */
    displayEventDetailsOnHover: false,
};
